import styled from 'styled-components';
import { P, fs, radius, card, eyebrow, eyebrowLabel, ease, onPhone, tint, tintB, tintT } from '../../theme/tokens';

export const Tiles = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 360px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const Tile = styled.div`
  ${card}
  ${(p) => p.$alert && `background: ${tint(P.warning)}; border-color: ${tintB(P.warning)};`}
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 20px;

  dt {
    ${eyebrow}
    letter-spacing: 0.14em;
    color: ${(p) => (p.$alert ? tintT(P.warning) : P.subtle)};
  }
  dd {
    margin: 0;
  }
  strong {
    display: block;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.1;
    color: ${(p) => (p.$alert ? tintT(P.warning) : P.ink)};
    font-variant-numeric: tabular-nums;
  }
  span {
    display: block;
    margin-top: 6px;
    font-size: ${fs.sm}px;
    color: ${P.subtle};
  }
`;

export const Page = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 20px;
  ${onPhone} {
    gap: 12px;
  }
`;

export const CardNote = styled.span`
  flex: 1;
  min-width: 0;
  font-size: ${fs.sm}px;
  color: ${P.subtle};
  ${onPhone} {
    flex-basis: 100%;
    font-size: ${fs.md}px;
    font-weight: 700;
    color: ${P.ink};
  }
`;

export const IconBtn = styled.button`
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border: 1px solid ${P.border};
  border-radius: ${radius.md}px;
  background: ${P.white};
  color: ${P.muted};
  cursor: pointer;
  transition: border-color 150ms ${ease}, color 150ms ${ease};

  &:hover {
    border-color: ${P.navy};
    color: ${P.navyInk};
  }
  &:focus-visible {
    outline: 2px solid ${P.navy};
    outline-offset: 2px;
  }
  svg {
    font-size: 12px;
  }
  ${onPhone} {
    width: 40px;
    height: 40px;
  }
`;

export const TodayBtn = styled(IconBtn)`
  width: auto;
  padding: 0 12px;
  font-family: inherit;
  font-size: ${fs.sm}px;
  font-weight: 600;

  &:disabled {
    opacity: 0.5;
    cursor: default;
    border-color: ${P.border};
    color: ${P.muted};
  }
`;

export const HeadTools = styled.div`
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  ${onPhone} {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    > button {
      flex: 1 1 calc(50% - 3px);
      white-space: nowrap;
      justify-content: center;
    }
    > ${IconBtn} {
      flex: none;
    }
    > ${TodayBtn} {
      flex: 1 1 auto;
    }
  }
`;

export const RulesGrid = styled.dl`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin: 0;

  ${onPhone} {
    grid-template-columns: minmax(0, 1fr);
  }
  dt {
    ${eyebrowLabel}
  }
  dd {
    margin: 4px 0 0;
    font-size: ${fs.base}px;
    font-weight: 600;
    color: ${P.ink};
  }
`;

export const DayRows = styled.fieldset`
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  border: none;

  legend {
    ${eyebrow}
    padding: 0;
    margin-bottom: 6px;
  }
`;

export const DayHead = styled.div`
  ${eyebrow}
  display: grid;
  grid-template-columns: 132px minmax(0, 1fr) minmax(0, 1fr);
  gap: 10px;
  ${onPhone} {
    grid-template-columns: 112px minmax(0, 1fr) minmax(0, 1fr);
    gap: 8px;
  }
`;

export const Hint = styled.small`
  grid-column: 2 / -1;
  font-size: ${fs.xs}px;
  color: ${P.subtle};
`;

export const DayRow = styled.div`
  display: grid;
  grid-template-columns: 132px minmax(0, 1fr) minmax(0, 1fr);
  align-items: center;
  gap: 10px;

  label {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: ${fs.sm}px;
    font-weight: 600;
    color: ${P.ink};
    cursor: pointer;
  }
  input[type='time'] {
    height: 36px;
  }
  input[type='time']:disabled {
    opacity: 0.45;
  }
  ${onPhone} {
    grid-template-columns: 112px minmax(0, 1fr) minmax(0, 1fr);
    gap: 8px;
    input[type='time'] {
      height: 36px;
    }
  }
`;

export const ErrorText = styled.p`
  margin: 0;
  font-size: ${fs.xs}px;
  color: ${P.danger};
`;
